module.exports = __webpack_public_path__ + "img/may-3.83a5f1f8.jpg";